import React, { useState, useEffect } from 'react';
import { useAppDispatch } from '../../../../hooks/redux';
import { AddProductsFromAnotherProjectModal, AddFromAProjectSpace  } from './AddFromAProjectModal.styles';
import { Text, CloseIcon } from '../../../../styles/common.styles';
import CustomSelectWithSearch from '../../../common/select/CustomSelectWithSearch';
import ModalTitle from '../../../common/modalTitle/ModalTitle';
import ModalFooter from '../../../common/modalFooter/ModalFooter';
import { blueDark01 } from '../../../../styles/colors';
import { Form } from 'antd';
import { ActionResponse } from '../../../../models/actionResponse/types';
import { getAvailableProjectsAction } from '../../../../redux/actions/projectActions';
import {
    AvailableProject,
} from '../../../../models/project/types';
import { SelectData } from '../../../../models/common/types';

interface Props {
    isOpen: boolean;
    projectId?: number;
    closeModal: (data: { key: 'copy' }) => void;
}

const AddFromAProjectModal: React.FC<Props> = ({
    isOpen,
    closeModal,
    projectId
}) => {
    const dispatch = useAppDispatch();

    const [projectsOptions, setProjectOptions] = useState<SelectData[]>([]);

    useEffect(() => {
        const fetchProjects = async () => {
            const { payload } = (await dispatch(
                getAvailableProjectsAction(),
                )) as ActionResponse<Array<AvailableProject>>;

            const options = payload?.data
            .map((project) => ({
                id: project.id.toString(),
                name: project.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));

            setProjectOptions(options)
        };

        fetchProjects();

    }, [dispatch]);

    const handleCancel = () => {
        closeModal({ key: 'copy' });
    };

    const onSubmit = async (data: { selectedProject: string }) => {
        if (data.selectedProject) {
            window.location.href = `/project-info/${data.selectedProject}/0/2?copyProductsTo=${projectId}`;
        }
    };

    return (
        <AddProductsFromAnotherProjectModal
            open={isOpen}
            onCancel={handleCancel}
            closeIcon={<CloseIcon/>}
            centered
            footer={null}
        >
            <ModalTitle title="Select a Project" icon="ic-modal-title-start-add-project.svg" />
            <Text weight={400} size={15} height={20} color={blueDark01}>
                Select the Project with the products you want to add.
            </Text>
            <Form onFinish={onSubmit}>
                <AddFromAProjectSpace>
                    <CustomSelectWithSearch
                        id="ProjectsToCopySelectModal"
                        label="Select Project"
                        name="selectedProject"
                        options={projectsOptions}
                        placeholder="Select one"
                        rules={[{ message: '' }]}
                        block
                        modallabel
                    />
                </AddFromAProjectSpace>
                    <ModalFooter action="Next" cancel={handleCancel} submit={() => {}} />
            </Form>
        </AddProductsFromAnotherProjectModal>
    );
};

export default AddFromAProjectModal;
